import { UUID } from 'types/shared/UUID';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';
import { IQueryResponse } from '../../types/rest/IQueryResponse';
import { convertFromIQueryResponseToIPageData, IPageData } from '../../types/rest/IPageData';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import { eInternalOrderStatus } from '../../ui-toolkit/enums/eInternalOrderStatus';
import { eSearchOrdersOrderBy } from '../../ui-toolkit/orders/searchOrder/types/eSearchOrdersOrderBy';
import { ISearchOrderData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface IOrderParams {
  internalContacts?: UUID[];
  lenderCompanyIds?: UUID[];
  clientCompanies?: UUID[];
  closingDateStart?: string | null;
  closingDateEnd?: string | null;
  createdAtStart?: string | null;
  createdAtEnd?: string | null;
  transactionCategories?: eTransactionCategory[] | null;
  orderStatuses?: eInternalOrderStatus[] | null;
  states?: eUSAState[] | null;
  pageNumber: number;
  pageSize: number;
  sortBy: eSearchOrdersOrderBy;
  city?: string | null;
  countyId?: string | null;
  zipCode?: string | null;
  tag?: UUID;
  excludeCanceledOrders?: boolean;
  excludeInactiveOrders?: boolean;
  settlementAgentId?: string;
  underwriterId?: string;
}

export const SearchOrdersByFilterParametersAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listPagedOrdersByFilterParams: build.query<IPageData<ISearchOrderData>, IOrderParams>({
      query: (body) => ({
        url: '/timber/api/internal/orders/multi-select',
        method: 'POST',
        body,
      }),
      transformResponse: (baseReturnValue: IQueryResponse<ISearchOrderData>) => {
        return convertFromIQueryResponseToIPageData(baseReturnValue, (data) => data);
      },
      providesTags: (result) => [
        ...(result?.content ?? []).map(({ id }) => ({ type: eAPITags.OrdersByFilterParams, id })),
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useListPagedOrdersByFilterParamsQuery } = SearchOrdersByFilterParametersAPI;
